module.exports = __webpack_public_path__ + "img/icon_bgm_stop.282971fa.png";